import React, { useContext, useState } from "react";
import {
  Typography,
  IconButton,
  Box,
  Stack,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { INFORMATION_FIELD_REQUEST } from "../../../../../../enums/ApiPaths";
import Wrapper from "../../../../../../components/wrappers/Wrapper";
import { useTranslation } from "react-i18next";
import { GlobalDataContext } from "../../../../../../contexts/GlobalData";
import {
  DELETE_CUSTOM_INFORMATION_FIELD,
  EDIT_CUSTOM_INFORMATION_FIELD,
} from "../../../../../../enums/PermissionTitles";
import { Settings } from "@mui/icons-material";
import InformationFieldChipsTab from "./InformationFieldChipsTab";
import useDelete from "../../../../../../hooks/useDelete";
import { ABOUT_US, INFO_FIELD } from "../../../../../../enums/QueryKeys";
import { overflowingTitleSx } from "../../../../../../enums/Styles";

export default function SingleInformationFieldFlip({ informationField }) {
  const [isAccordionExpanded, setIsAccordionExpanded] = useState(false);
  const { t, i18n } = useTranslation();
  const { isPermissionAllowed } = useContext(GlobalDataContext);
  const translations = informationField?.labelTranslation;
  const currentLanguage = i18n.language;
  const translatedTitle =
    translations[currentLanguage] || informationField?.label;

  const { deleteFn, ConfirmationDialog } = useDelete(
    informationField?.id,
    INFORMATION_FIELD_REQUEST,
    INFO_FIELD,
    "DeleteInformationFieldConfirmation",
    null,
    [ABOUT_US]
  );

  const handleAccordionToggle = () => {
    setIsAccordionExpanded(!isAccordionExpanded);
  };

  async function handleDelete() {
    await deleteFn();
  }

  return (
    <Box mb={2}>
      <Accordion
        expanded={isAccordionExpanded}
        onChange={handleAccordionToggle}
        data-testid={`clinic.info-fields.item.${informationField?.id}`}
      >
        <AccordionSummary
          expandIcon={
            <IconButton
              disabled={!isPermissionAllowed(EDIT_CUSTOM_INFORMATION_FIELD)}
              title={t("Settings")}
              data-testid={`clinic.info-fields.item.${informationField?.id}.expand-button`}
            >
              <Settings />
            </IconButton>
          }
        >
          <Wrapper noPaper>
            <Typography variant="h6"
            sx={overflowingTitleSx}
            data-testid={`clinic.info-fields.item.${informationField?.id}.title`}
            >
                {translatedTitle}
            </Typography>
            <Stack direction={"horizontal"} spacing={2}>
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  handleDelete();
                }}
                disabled={!isPermissionAllowed(DELETE_CUSTOM_INFORMATION_FIELD)}
                color="error"
                title={t("Delete")}
                data-testid={`clinic.info-fields.item.${informationField?.id}.delete-button`}
              >
                <DeleteIcon />
              </IconButton>
            </Stack>
          </Wrapper>
        </AccordionSummary>
        <AccordionDetails>
          <InformationFieldChipsTab informationField={informationField} />
        </AccordionDetails>
      </Accordion>
      <ConfirmationDialog />
    </Box>
  );
}
